export enum UrgencyType {
  NCNS = 1,
  LATE_CANCELLATION = 2,
  LAST_MINUTE = 3,
}

export enum UrgencyReason {
  WORKER_REPLACEMENT_REQUESTED = "WORKER_REPLACEMENT_REQUESTED",
  ATTENDANCE_TRACKING_ALGO = "ATTENDANCE_TRACKING_ALGO",
  LATE_CANCELLATION = "LATE_CANCELLATION",
  MAGIC_SHIFT = "MAGIC_SHIFT",
}

export const WORKER_ETA_BUFFER_IN_MINUTES = 15;

export const LEAD_TIME_TO_SHOW_REPLACEMENT = 2;

export const REPLACEMENT_REQUEST_TIME_PERCENTAGE = 0.25;

export const WORKER_ETA_DISTANCE_TOLERANCE = 100;
